var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 800,
    viewBox: "-60 -40 120 80",
    width: 1200,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#e70013"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-60-40H60v80H-60z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#fff",
    r: 20
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0-15A15 15 0 00-15 0 15 15 0 000 15a15 15 0 0012.102-6.165A12 12 0 014 12 12 12 0 01-8 0 12 12 0 014-12a12 12 0 018.101 3.167A15 15 0 000-15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-5 0l16.281-5.29L1.22 8.56V-8.56L11.28 5.29z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTn);
export default __webpack_public_path__ + "static/media/tn.9e6d7086db953e81ac9e9106eafa3d9d.svg";
export { ForwardRef as ReactComponent };